module.exports = __webpack_public_path__ + "img/navicon_shop.48839d9f.png";